import { IAddress } from "../components/app/entityComponents/Form/components/FormAddress";

export function lowerCaseFirstLetter(string: string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatAddressString(address: IAddress | undefined) {
    return formatAddressParts(address).join('\n');
}

export function joinAddressString(address: IAddress | undefined) {
    return formatAddressParts(address).join(', ');
}

export function pascalToReadable(text: string) {
    return text.replace(/([A-Z])/g, ' $1').trim();
}

export function formatAddressParts(address: IAddress | undefined): string[] {
    if (!address) return [];

    const {
        companyStreet,
        address1,
        address2,
        city,
        county,
        zip,
        country
    } = address;

    const otherParts = [address1, address2, city, county, zip, country]
        .filter(part => part && part.trim() !== "");

    // If companyStreet exists and no other address parts exist,
    // split companyStreet by newline and use those parts
    if (companyStreet && companyStreet.trim() !== "" && otherParts.length === 0) {
        return companyStreet
            .split(/\r?\n/)
            .map(part => part.trim())
            .filter(part => part !== "");
    }

    // Default behavior
    const allParts: string[] = [
        companyStreet,
        address1,
        address2,
        city,
        county,
        zip,
        country
    ];

    return allParts.filter(part => part && part.trim() !== "");
}
